module.exports = __webpack_public_path__ + "img/icon-vip-yellow@2x.4271c5c8.png";